module.exports = __webpack_public_path__ + "img/jewellery.0c84b87.png";